enum ExpenseReportTableType {
  ReportDraft = 'ReportDraft',
  ReportSubmitted = 'ReportSubmitted',
}
export default ExpenseReportTableType;
